<script>
import Layout from "@/views/layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import UserSSOAPI from "@/services/sso/users/userSSOAPI";
import EmployeeAPI from "@/services/employee/employeeAPI";
import Swal from "sweetalert2";
import CheckModal from "@/components/CheckModal";
import LogTable from "@/components/standard/ResponsibleSGSST/ResponsibleLogTable";
import Table from "@/components/standard/ResponsibleSGSST/components/ResponsibleTable";
import newScoresAPI from "../../../services/newScores/newScoresAPI"
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import { sendNotification } from "@/utils/helpers/notification";
import ItemAPI from "@/services/items/itemsAPI";
import revised_objetivesAPI from "@/services/standards/revised_objetives/revised_objetivesAPI";

export default {
  page: {
    title: "2.2.1 Objetivos del SG SST",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    LogTable,
    Table,
    CheckModal,
  },
  data() {
    return {
      title: "2.2.1 Objetivos del SG SST",
      items: [
        {
          text: "Estándares",
          href: "/forms/estandares",
        },
        {
          text: "Objetivos definidos",
          active: true,
        },
      ],

      submitted: false,

      role: 2,

      itemData: null,

      item1: null,

      revisedO: {
        objective: null,
        meta_simbol: null,
        meta_number: null,
        indicator: null,
        frequency: null,
        status: true,
        companies_id: 1,
      },

      userSelected: null,
      usersList: [],

      list: [],

      company: "",

      employeeDesignSST: "",

      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      company: this.$store.getters["company/getCompany"] || null,
      user: this.$store.state.auth || null,

      loading: true,
    };
  },

  methods: {
    /**
     *This method get the item data.
     */
    getItemData() {
      ItemAPI.getItems(13)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    /**
     * This method indicates whether the company has a classification corresponding to
     * the permit for the item in question.
     * @param {JSON} item The item object.
     */
    allowAccess() {
      try {
        const item = this.itemData;

        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"]
              .company_classification_id || null;

          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    /**
     * This method is used to send notification to SST user and SST company.
     * The sendNotification method import is required.
     * @param {Number} messageID - The message ID that will be associated to notification.
     * @param {Number} itemID - The item ID that will be associated to notification.
     * @param {Boolean} user - The user that will e associated to notification.
     * @return {Boolean} True if the notification is sent, false if not.
     */
    sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(company.id, user ? company.id_diseno_sso : null, messageID, itemID);
    },

    /**
     * This method is used to knows if the user has the permission indicated
     * @param {String} name The name of the permission
     * @param {Array} roles the roles that permitted to access the action
     * @returns {Boolean} true if the user has the permission indicated or false if no
     */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role
        ? this.$store.state.auth.info.role
        : null;

      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false;
        } // Close if the roles arrays is not empty

        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role =
            role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
        } // Close if the roles arrays is empty

        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions;

        // Know if the user has the permission indicated
        const enabled = permissions.find(
          (permission) => permission.name === name
        );

        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false;
      } // Close if the user is logged

      // If the user is not logged
      else {
        return false;
      } // Close else the user is not logged
    },

    changeStatusValue() {
      this.sg_sstData.status = !this.sg_sstData.status;
    },

    getRevised() {
      revised_objetivesAPI
        .getRevised(this.$route.params.id)
        .then((response) => {
          this.revisedO = {
            objective: response.objective,
            meta_simbol: response.meta_simbol,
            meta_number: response.meta_number,
            indicator: response.indicator,
            frequency: response.frequency,
            status: response.status,
            companies_id: response.companies_id,
          };
        })
        .catch((error) => {
          console.log(error);
          this.loading = false
        });
    },


    update() {
      revised_objetivesAPI
        .updateRevisedO(this.$route.params.id, {
          objective: this.revisedO.objective,
          meta_simbol: this.revisedO.meta_simbol,
          meta_number: this.revisedO.meta_number,
          indicator: this.revisedO.indicator,
          frequency: this.revisedO.frequency,
          status: this.revisedO.status,
          companies_id: this.revisedO.companies_id,
        })
        .then((response) => {

          const itemChange = {
            companies_id: this.companyID,
            item_id: 13,
            status: 'Pendiente',
          };
          newScoresAPI.calculateScores(itemChange)
            .then((response) => {
              setTimeout(() => {
            Swal.fire({
              title: "¡Se ha actualizado con éxito!",
              text: "¡Se ha actualizado con éxito!",
              icon: "success",
              confirmButtonClass: "btn btn-confirm mt-2",
            });
            this.$router.go(-1);
          }, 1000)
            })
            .catch((error) => {
              this.loading = false
              setTimeout(() => {
                Swal.fire({
                  title: "Error",
                  text: "¡No se ha podido registrar!",
                  icon: "error",
                  type: "error",
                  confirmButtonClass: "btn btn-confirm mt-2",
                });
                window.location.reload();
              }, 1000);
              console.log(error);
            });
        }).catch((err) => {
          console.log("error: ", err);
        });
    },

    async getUsers() {
      try {
        const { data } = await UserSSOAPI.getAllAdmin();
        const users = data;
        if (users && users.length > 0) {
          let designUser = users.find(
            (item) => item.id == this.company.id_diseno_sso
          );
          this.employeeDesignSST = designUser;
        }
        const { employee } = await EmployeeAPI.getAll(this.companyID);
        const list = employee.filter((item) => item.id_implementation_sso);
        this.usersList = list || null;
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    goBack() {
      this.$router.go(-1);
    },

    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 13)
        .then(response => {
          this.item = response || null
        })
        .catch(error => {
          console.log(error)
        })
    },

  },

  mounted() {
    this.getUsers();
    this.getItems();
    this.getRevised()
    this.getItemData();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">

        <div v-if="!loading">
          <div class="card">

            <div class="card-body">
              <div class="row">

                <div class="col-md-6 col-sm-12">

                  <CheckModal>

                  </CheckModal>
                </div>

              </div>

              <form calss="form-group" @submit.prevent="update">
                <div class="form-row pt-3">
                  <b-form-group class="col-md-12 px-2" label="Objetivo" label-for="file">
                    <b-form-textarea type="date" id="note" v-model="revisedO.objective">
                    </b-form-textarea>
                  </b-form-group>

                </div>

                <div class="form-row">
                  <b-form-group label-for="number" class="col-md-6 px-2" label="Estado">
                    <select id="type" :disabled="!getRole('Editar') || !allowAccess()" class="form-control"
                      v-model="revisedO.status">
                      <b-form-select-option value="1">
                        Activo
                      </b-form-select-option>
                      <b-form-select-option value="0">
                        Inactivo
                      </b-form-select-option>
                    </select>
                  </b-form-group>

                  <b-form-group label-for="number" class="col-md-6 px-2" label="Frecuencia de medición">
                    <select id="type" :disabled="!getRole('Editar') || !allowAccess()" class="form-control"
                      v-model="revisedO.frequency">

                      <b-form-select-option value="Mensual">
                        Mensual
                      </b-form-select-option>
                      <b-form-select-option value="Bimensual">
                        Bimensual
                      </b-form-select-option>
                      <b-form-select-option value="Trimestral">
                        Trimestral
                      </b-form-select-option>
                      <b-form-select-option value="Semestral">
                        Semestral
                      </b-form-select-option>
                      <b-form-select-option value="Anual">
                        Anual
                      </b-form-select-option>
                    </select>
                  </b-form-group>
                </div>

                <div class="form-row">

                  <b-form-group label-for="number" class="col-md-4 px-2" label="Meta">
                    <select id="type" :disabled="!getRole('Editar') || !allowAccess()" class="form-control"
                      v-model="revisedO.meta_simbol">
                      <b-form-select-option value="<">
                        &lt;
                      </b-form-select-option>
                      <b-form-select-option value=">=">
                        &ge;
                      </b-form-select-option>

                    </select>
                  </b-form-group>
                  <b-form-group label-for="number" class="col-md-4 " label="Numero">
                    <b-form-input :disabled="!getRole('Editar') || !allowAccess()" type="number" id="date_exam"
                      v-model="revisedO.meta_number">
                    </b-form-input>
                  </b-form-group>

                  <b-form-group label-for="indicator" class="col-md-4 px-2" label="Indicador">
                    <b-form-input :disabled="!getRole('Editar') || !allowAccess()" type="text" id="date_exam"
                      v-model="revisedO.indicator">
                    </b-form-input>
                  </b-form-group>

                </div>
                <div class="form-group text-right m-b-0">
                  <button :disabled="!getRole('Editar') || !allowAccess()" type="submit" class="btn btn-primary">
                    Guardar
                  </button>
                  <button type="button" class="btn btn-secondary mx-1" @click="goBack">
                    Cancelar
                  </button>
                </div>

              </form>
            </div>
          </div>

        </div>

        <div v-else>
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>

      </div>
    </div>
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>